// extracted by mini-css-extract-plugin
module.exports = {"resultsGrid":"TeamsTile_resultsGrid__2dryt"};